import { findLinks, splitLinks } from '../lib/links';

/**
 * Plain text with its web links clickable — see `lib/links`. Opens in a new tab, so following a
 * link from a comment does not lose the task it was read on; `noopener` so the page it opens
 * cannot reach back into this one.
 */
export function Linkified({ text }: { text: string }) {
  return (
    <>
      {splitLinks(text).map((part, index) =>
        part.href ? (
          <a key={index} href={part.href} target="_blank" rel="noopener noreferrer" className="text-link">
            {part.text}
          </a>
        ) : (
          <span key={index}>{part.text}</span>
        ),
      )}
    </>
  );
}

/**
 * The links in a box somebody is typing in, listed under it. A link inside a `<textarea>` cannot
 * be clicked — the box is for editing — so a task description pasted full of links was, for
 * everybody who may edit it, the one place they could not follow them. Nothing when there are
 * none.
 */
export function LinksIn({ text }: { text: string }) {
  const links = findLinks(text);
  if (links.length === 0) return null;
  return (
    <span className="field-hint links-in">
      {links.length === 1 ? 'Link:' : 'Links:'}{' '}
      {links.map((href, index) => (
        <span key={href}>
          {index > 0 && ' · '}
          <a href={href} target="_blank" rel="noopener noreferrer" className="text-link">
            {href.replace(/^https?:\/\//, '')}
          </a>
        </span>
      ))}
    </span>
  );
}
